import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const RemoveDataInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  let body = req.body;
  if (typeof body === 'object' && body !== null) {
    if (body['_attachments'] != undefined) {
      delete body['_attachments'];
      delete body['_etag'];
      delete body['_rid'];
      delete body['_self'];
      delete body['_ts'];
    }
  } else if (Array.isArray(body)) {
    body = body.map(item => {
      if (body['_attachments']) {
        delete item['_attachments'];
        delete item['_etag'];
        delete item['_rid'];
        delete item['_self'];
        delete item['_ts'];
      }
      return item;
    });
  }

  const clonedRequest = req.clone({ body });
  return next(clonedRequest);
};
